"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "borderRadius", {
    enumerable: true,
    get: ()=>borderRadius
});
const borderRadius = {
    borderRadiusNone: '0',
    borderRadiusSmall: '2px',
    borderRadiusMedium: '4px',
    borderRadiusLarge: '6px',
    borderRadiusXLarge: '8px',
    borderRadiusCircular: '10000px'
}; //# sourceMappingURL=borderRadius.js.map

//# sourceMappingURL=borderRadius.js.map